import React, { useEffect, useState }  from "react";
import { getSettings, updateSettings } from "../../Redux/actions/workers";
import { addNotification} from "../../Utilities/notifications";

import { ReactMultiEmail , isEmail} from 'react-multi-email';
import "./index.css";
import ismail from  'isemail';
import "react-multi-email/style.css";
import axios from 'axios';


function SettingsWorker(props) {
    let { worker : { worker_name, worker_id } } = props;
    let [viewData, setViewData ] = useState();
    let [emailItems, setEmailItems ] = useState([]);
    let [emailErr, setEmailErr ] = useState(false);
    let [enabled, setEnabled] = useState(false);

    useEffect( ()=>{
        async function fetchData(){
            let data = await getSettings(worker_id); 
            if(data){
                setViewData(data)
                setEmailItems(data.email_items)
                setEnabled(data.enabled)
            }
        }
        fetchData();
    },[worker_id]);

    const checkCondition =(e)=>{
        setEnabled(e.target.checked);
     }

    const  update= async()=>{
        let emails=[]
        let arr = []
        emailItems.forEach((item) => {
            emails.push(ismail.validate(item))
        })
        for (const element of emailItems) {
            let {data}=await axios.get(`https://open.kickbox.com/v1/disposable/${element}`)
             arr.push(data.disposable)
        }
        let isemail = arr.indexOf(true) !== -1; 
        if (!emails.includes(false) && !isemail) {
            let obj={
                ...viewData,
                enabled,
                email_items:emailItems
            }
            let status = await updateSettings(obj);
            if(status && status===200){
                addNotification({
                    title: "Techforce.ai",
                    message: "Updated Successfully",
                    type: "success",
                });
            }
            props.toggle()
        } else {
            console.log("elseeeeee");
            setEmailErr(true)
        }
    } 

    return (
        <div>
            <div>
            <label>{ worker_name } worker emails configurations </label>
            </div>
            {
                viewData?
                <div className="form-container">
                    <div className ="email_items">
                        {
                            <ReactMultiEmail
                            placeholder="e-mails"
                            emails={emailItems}
                            onChange={(_emails: string[]) => {
                                setEmailItems(_emails)
                                setEmailErr  (false)                 

                            }}
                            validateEmail={async email => { 
                                return isEmail(email) // return boolean
                            }}
                            getLabel={(
                                email: string,
                                index: number,
                                removeEmail: (index: number) => void
                            ) => {
                                return (
                                    <div data-tag key={index}>
                                        {email}
                                        <span data-tag-handle onClick={() => removeEmail(index)}>
                                            ×
                                        </span>
                                    </div>
                                );
                            }}
                        />
                        }
                    </div>
                    {emailErr && 
                            <span className='error'>Please enter valid emailId</span>}

                    <div className="form-group form-check" style={{ marginTop: "7px" }}>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            name="enabled"
                            //value={enabled}
                            checked={enabled}
                            onChange={checkCondition}
                        />
                        <label className="form-check-label" >Enabled</label>
                    </div>
                    <div className="text">
                        <button className="btn" onClick={update}>
                            Update
                        </button>
                        <button className="btn danger-button" onClick={()=>props.toggle()} >
                            Cancel
                        </button>
                    </div>
                </div>:null
            }
        </div>
        
    )
}
export default SettingsWorker;